import SearchHead from "components/searchHead";
import { SEARCH_FORM_ID_USER } from "components/constent";
import SearchForm from "./searchForm";
import UserList from "./list";
import { UserFilterProvider, UserParamsProvider } from "./context";

export default function UserPage() {
  return (
    <>
      <SearchHead
        title={"회원조회"}
        formId={SEARCH_FORM_ID_USER}
        onClick={() => {}}
      />
      <UserParamsProvider>
        <UserFilterProvider>
          <SearchForm />
        </UserFilterProvider>
        <UserList />
      </UserParamsProvider>
    </>
  );
}
